var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    [
      _c(
        "q-table",
        {
          attrs: {
            data: _vm.history,
            columns: _vm.columnsOnView(),
            "row-key": "id",
            flat: "",
            pagination: _vm.pagination,
            loading: _vm.loading,
            "rows-per-page-options": [5, 10, 50, 100]
          },
          on: {
            "update:pagination": function($event) {
              _vm.pagination = $event
            },
            request: _vm.request
          },
          scopedSlots: _vm._u([
            {
              key: "body-cell-status_from",
              fn: function(props) {
                return [
                  _c(
                    "q-td",
                    { attrs: { props: props } },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            icon: _vm.getRedeemStatusIcon(
                              props.row.status_from
                            ),
                            color: _vm.getRedeemStatusColor(
                              props.row.status_from
                            )
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.getRedeemStatus(props.row.status_from) ||
                                  "-"
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "body-cell-status_to",
              fn: function(props) {
                return [
                  _c(
                    "q-td",
                    { attrs: { props: props } },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            icon: _vm.getRedeemStatusIcon(props.row.status_to),
                            color: _vm.getRedeemStatusColor(props.row.status_to)
                          }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.getRedeemStatus(props.row.status_to) || "-"
                              ) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "template",
            { slot: "top" },
            [
              _c("q-search", {
                staticClass: "q-my-md",
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.request({ pagination: _vm.pagination })
                  }
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c(
            "q-tr",
            { attrs: { slot: "bottom-row" }, slot: "bottom-row" },
            [
              _c(
                "q-td",
                { attrs: { colspan: "100%" } },
                [
                  _c(
                    "q-btn",
                    {
                      attrs: {
                        flat: "",
                        round: "",
                        dense: "",
                        color: "secondary",
                        size: "small",
                        icon: "far fa-cog"
                      },
                      on: {
                        click: function($event) {
                          _vm.show_modal = true
                        }
                      }
                    },
                    [
                      _c("q-tooltip", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("configure_table_tooltip")) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      ),
      _c(
        "q-modal",
        {
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveColumns()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("personalize_columns")) +
                        "\n\t\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-md" },
                  _vm._l(_vm.columns, function(column, index) {
                    return column.name !== "actions" && column.name !== "id"
                      ? _c(
                          "div",
                          { key: index, staticClass: "col-xs-12 col-sm-4" },
                          [
                            _c("q-checkbox", {
                              attrs: { label: _vm.$t(column.label) },
                              model: {
                                value: column.show,
                                callback: function($$v) {
                                  _vm.$set(column, "show", $$v)
                                },
                                expression: "column.show"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _c("div", { staticClass: "row reverse gutter-md q-mt-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "fit",
                        attrs: {
                          icon: "fal fa-times",
                          color: "primary",
                          label: _vm.$t("close")
                        },
                        on: {
                          click: function($event) {
                            return _vm.saveColumns()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }